// extracted by mini-css-extract-plugin
export default {"root":"styles_root__KS7-Q","container":"styles_container__CneVZ","popup":"styles_popup__9BLkN","content":"styles_content__CeFgz","close":"styles_close__Naow3"};